export default {
  computed: {
    variantsIndexName () {
      return this.$config.ALGOLIA_VARIANTS_INDEX_NAME
    },
    objectIDs () {
      return [this.selectedVariant]
    }
  },
  methods: {
    sendAddToCartEventToAlgolia () {
      let eventName = this.queryId ? 'add_to_cart_after_search' : 'add_to_cart'

      this.sendEventToAlgolia(eventName)
    },
    sendPurchasedEventToAlgolia () {
      this.sendEventToAlgolia('purchased')
    },
    sendEventToAlgolia (eventName) {
      window.dataLayer.push({ event: eventName })
    }
  }
}